import { useLazyQuery } from '@apollo/client'

import { GetCreateProductValuesInvoiceDocument } from '@/graphql/purchase-plus/generated/getCreateProductValuesInvoice.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import useInvoiceId from '@/modules/shared/hooks/params/useInvoiceId'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

export const useGetLazyCreatedProductValuesInvoice = () => {
  const invoiceId = useInvoiceId()
  const [fetchCreatedProductValuesInvoice, { data, networkStatus, error, refetch }] = useLazyQuery(
    GetCreateProductValuesInvoiceDocument,
    {
      variables: {
        invoiceId: Number(invoiceId),
      },
      context: {
        uri: PURCHASE_PLUS_GRAPHQL_API,
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
    }
  )

  const invoice = data?.invoice

  const loadingStates = checkNetworkStatus(networkStatus)

  return {
    fetchCreatedProductValuesInvoice,
    error,
    invoice,
    loadingStates,
    refetch,
  }
}
